// Free-tier region constant + bbox intersection helper.
//
// 2026-06-02: free-tier window moved from Helgeland to inner Vestlandet
// (Sogn / Sunnfjord / Sunnmøre). The new window covers Ørsta, Årdal,
// Moskog, and Grytten and intersects more confirmed-capacity substations
// from the upstream /assess-station endpoint — capacity-first demos now
// land on at least one Sufficient + ~25 Partial cards instead of the
// "0 confirmed, inquire-and-wait" pattern Helgeland had.
//
// Renamed from HELGELAND_BBOX → FREE_TIER_BBOX on 2026-06-02 so the
// name matches the meaning (this file still lives at helgeland.js
// because of import paths — that file rename is a separate cleanup).
// Three places hold this same value and MUST stay in sync:
//   - this file
//   - backend/app/core/tier_enforcement.py
//   - backend/app/api/sites_cached_pool.py

export const FREE_TIER_BBOX = {
  min_lat: 61.04,
  max_lat: 62.55,
  min_lon:  5.63,
  max_lon:  8.00,
};

// Default bbox for PREMIUM users whose mapBounds is null on the first
// search (initial load before any pan/zoom). Roughly covers southern
// Norway including the main load centres (Oslo, Bergen, Stavanger,
// Trondheim) — the region where most DC interest concentrates. The
// capacity-first chain uses this as the bbox center for the upstream
// /assess-station call. Without this default, premium previously
// silently fell back to FREE_TIER_BBOX (inner Vestlandet) for the
// first search — same geography as free tier, defeating the premium
// value prop.
//
// This is a UX default, not a hard cap — the user can zoom anywhere
// and the next search uses the actual viewport. Backend honours the
// supplied bbox without re-clamping for premium.
export const NO_PREMIUM_DEFAULT_BBOX = {
  min_lat: 58.0,
  max_lat: 65.0,
  min_lon:  4.5,
  max_lon: 12.0,
};

// Returns the rectangular intersection of two bboxes (same shape as
// `mapBounds` produced by SiteScreener.handleMapMove), or null if they
// don't overlap. Used to clamp non-premium screening requests to the
// allowed region — the frontend's enforcement is UX; the backend
// re-clamps for security.
export function intersectBbox(a, b) {
  if (!a || !b) return null;
  const r = {
    min_lat: Math.max(a.min_lat, b.min_lat),
    max_lat: Math.min(a.max_lat, b.max_lat),
    min_lon: Math.max(a.min_lon, b.min_lon),
    max_lon: Math.min(a.max_lon, b.max_lon),
  };
  if (r.min_lat >= r.max_lat || r.min_lon >= r.max_lon) return null;
  return r;
}
